<template>
  <div class="breadcrumb">
    <h2>
      <span class="crumb">
        <router-link :to="{ name: 'trips' }">Dashboard</router-link>
        <span class="icon">></span>
        <router-link :to="{ name: 'trips' }">Trips</router-link>
        <span class="icon">></span>
      </span>
      <span>{{ title }}</span>
    </h2>
    <div class="method">
      <span>{{ method }}&nbsp;&middot;&nbsp;<a @click="reset">Change</a></span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const emit = defineEmits(["update:stage"]);
const props = defineProps({
  stage: String,
  wizard: String,
});

const method = computed(() => {
  if (props.wizard === "book") {
    return "Self Booking";
  } else if (props.wizard === "assist") {
    return "Assisted Booking";
  } else {
    return "Concierge";
  }
});
const title = computed(() => {
  if (props.wizard === "concierge") {
    return "Create a Request";
  } else {
    return "Book a Trip";
  }
});

const reset = () => {
  emit("update:stage", "guide");
};
</script>

<style lang="less">
#new {
  .method {
    margin-bottom: 1rem;

    span {
      padding-right: 0.5rem;
    }
  }
}

@media screen and (min-width: 60em) {
  #new {
    .method {
      float: right;
      margin-bottom: 0;
    }
  }
}
</style>
